import React from 'react';
import styled from 'styled-components';

export const FormLabel = styled.span`
  font-size: 12px;
  letter-spacing: 0.6px;
  color: #555555;
`;

const TinyFormLabel = styled(FormLabel)`
  font-family: BrandonGrotesque-Regular;
  color: #888888;
`;

export const FormLabelBox = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
`;

export const ComplexLabel = ({ first, second, ...rest }) => (
  <>
    <FormLabel>{first} </FormLabel>
    {rest.row && <br />}
    <FormLabel style={{ color: '#b4a361' }}>{second} </FormLabel>
    {rest.optional && <TinyFormLabel>(optional)</TinyFormLabel>}
  </>
);

export const ProfileSaveButton = styled.div`
  width: 57px;
  height: 25px;
  font-family: BrandonGrotesque-Regular;
  background-color: var(--color-gunmetal);
  font-size: 15px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  color: #ffffff;
`;

export const CategoryName = styled.div`
  font-size: 14px;
  color: #555555;
  padding-left: 8px;
  font-family: BrandonGrotesque-Regular;
  padding-bottom: 15px;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  border: solid 2px var(--color-white-two);
`;

export const RemoveImageIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: var(--color-gunmetal);
  width: 15px;
  height: 15px;
  line-height: 13px;
  text-align: center;
  border-radius: 20px;
  font-size: 15px;
  color: white;
  cursor: pointer;
`;

export const ImportImageButton = styled.div`
  width: 200px;
  border-radius: 2px;
  background-color: var(--color-cool-grey);
  font-family: BrandonGrotesque-Medium;
  font-size: 14px;
  line-height: 42px;
  letter-spacing: 0.6px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 12px;
  cursor: pointer;
`;

export const MediaItem = styled.div`
  width: 85px;
  margin: 10px 10px 10px 10px;
  box-shadow: 0 10px 20px 0 rgba(45, 48, 60, 0.15);
  cursor: pointer;
  display: inline-block;
  position: relative;
`;

export const OfferContainerImage = styled.img`
  margin-bottom: 5px;
  cursor: pointer;
`;

const Hamburger = styled.div`
  width: 20px;
  height: 2px;
  background-color: white;
  margin: 4px 0;
`;

const HamburgerIcon = styled.div`
  float: right;
  margin-right: 25px;
  margin-top: 15px;
  cursor: pointer;
`;

export const HamburgerMenu = ({ onClick }) => (
  <HamburgerIcon onClick={onClick}>
    <Hamburger />
    <Hamburger />
    <Hamburger />
  </HamburgerIcon>
);

export const OfferFormTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  padding-top: 30px;
  color: #333333;
`;
